import { h } from 'vue'
import ImgComponent from '@/presentation/components/img/ImgComponent.vue'
import components from '@/project/components/components'
import InfoBlock from '../InfoBlock.vue'
import GroupBlock from '../GroupBlock.vue'
import ChecklistBlock from '../ChecklistBlock.vue'
import ButtonGroupBlock from '../ButtonGroupBlock.vue'
import SectionBlock from '../SectionBlock.vue'

const componentMap = {
  InfoBlock,
  GroupBlock,
  ChecklistBlock,
  ButtonGroupBlock,
  SectionBlock,
  ImgComponent,
  ...components,
}

function resolveComponents(data) {
  if (Array.isArray(data)) {
    return data.map(resolveComponents)
  }

  if (typeof data === 'object' && data !== null) {
    const result = {}

    for (const key in data) {
      if (key === 'component' && typeof data[key] === 'string') {
        result[key] = componentMap[data[key]] || warningComponent(data[key])
      } else {
        result[key] = resolveComponents(data[key])
      }
    }

    return result
  }

  // valeur primitive
  return data
}

function warningComponent(name = 'undefined') {
  return function render() {
    return h('div', `⚠️ Unknown section: ${name}`)
  }
}

export default resolveComponents
